if(!customElements.get('product-sample-qty-limit')){
    class ProductSampleQtyLimit extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.selectors = {
                form: this.querySelector('form')
            }
            document.addEventListener('shopify:qty-limit', async (e) => {
               await fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    const cartFound = cart.items.filter(item => parseInt(item.id) === parseInt(this.selectors.form.dataset.variantId));
                    if(cartFound.length > 0) {
                        this.selectors.form.dataset.cartQty = cartFound[0].quantity;
                        const addBtn = this.querySelector('button');
                        if(parseInt(this.selectors.form.dataset.qtyLimit) > parseInt(cartFound[0].quantity)) {  
                            addBtn && (addBtn.querySelector('span').textContent = `${this.selectors.form.dataset.fallbackText}`);
                            addBtn && (addBtn.removeAttribute('aria-disabled'));
                        } else {
                            addBtn && (addBtn.querySelector('span').textContent = `${this.selectors.form.dataset.maxLimitText}`);
                            addBtn && (addBtn.setAttribute('aria-disabled', true));
                        }
                    } else {
                        this.selectors.form.dataset.cartQty = 0;
                        const addBtn = this.querySelector('button');
                        addBtn && (addBtn.querySelector('span').textContent = `${this.selectors.form.dataset.fallbackText}`);
                        addBtn && (addBtn.removeAttribute('aria-disabled'));
                    }
                });
            });
        }
    }
    customElements.define('product-sample-qty-limit', ProductSampleQtyLimit);
}